// extracted by mini-css-extract-plugin
export var button = "modal-content-start-module--button--d355a";
export var content = "modal-content-start-module--content--8bb9b";
export var copy = "modal-content-start-module--copy--280b6";
export var image = "modal-content-start-module--image--02ff7";
export var title = "modal-content-start-module--title--9486c";
export var window = "modal-content-start-module--window--cfe28";